import { useState } from 'react';
import { ApiError, api } from '@/lib/api';

/** Small action under a live event's English gloss. Rewrites that one title for everyone. */
export function FixTranslation({ title, onFixed }: { title: string; onFixed: (english: string) => void }) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function fix() {
    if (pending) return;
    setPending(true);
    setError(null);
    try {
      const result = await api.post<{ english: string }>('/events/fix-translation', { title }, 20000);
      onFixed(result.english);
    } catch (err) {
      const message = err instanceof ApiError ? err.message : 'Translation couldn’t be fixed just now.';
      setError(message);
    } finally {
      setPending(false);
    }
  }

  return (
    <span className="fix-translation">
      <button type="button" className="fix-translation__btn" onClick={() => void fix()} disabled={pending}>
        {pending ? 'Fixing translation…' : 'Fix translation'}
      </button>
      {error ? (
        <span className="fix-translation__error" role="alert">
          {error}
        </span>
      ) : null}
    </span>
  );
}
